// Youtube Icon:

import React from 'react'

const Youtube = () => (
  <svg width="24px" viewBox="0 0 32 24.79" version="1.1">
    <path d="M16,0C.28,0,0,1.41,0,12.4S.28,24.79,16,24.79,32,23.38,32,12.4,31.72,0,16,0Zm5.13,12.93-7.19,3.38a.75.75,0,0,1-1.14-.74V9.22a.75.75,0,0,1,1.14-.74l7.19,3.38C21.76,12.15,21.76,12.64,21.13,12.93Z" />
  </svg>
)

export default Youtube
